/**
 * アプリケーション全体で使用するロガー
 * 開発環境ではコンソールに出力、本番環境では機密情報を出力しない
 *
 * 共有モジュール（frontend/shared/auth）。各アプリの lib/logger.ts はここを再エクスポートする。
 */

const isDevelopment = process.env.NODE_ENV === 'development'

export const logger = {
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args)
    }
  },
  error: (message: string, error?: any) => {
    if (isDevelopment) {
      console.error(message, error)
    } else {
      console.error(message)
      // TODO: 本番環境ではログサービス（CloudWatch, Sentry等）に送信
    }
  },
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args)
    }
  },
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args)
    }
  },
}
